import axios from 'axios';

export const API = axios.create({ baseURL: process.env.REACT_APP_SERVER_URL ?? 'http://localhost:5000/api' });

API.interceptors.request.use(config => {
    if (!localStorage.getItem("profile")) {
        return config;
    }

    const { token } = JSON.parse(localStorage.getItem("profile"));

    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
}, error => Promise.reject(error));

API.interceptors.response.use(response => response, errorResponse => {
    if (errorResponse.status === 403 && errorResponse.response.data.errorType === "unauth") {
        window.location.href = "/authorization";
    }
    return Promise.reject(errorResponse);
});

export const signUp = (formData) => API.post('/user/signup', formData);
export const signIn = (formData) => API.post('/user/signin', formData);
export const logOut = () => API.post('/user/logout');

// TODO: Integrate with pages & test for functionality
export const updateUserRole = (id, roleType) => API.patch(`/user/updateRole/${id}`, roleType);
export const updateProfile = (id, formData) => API.patch(`/user/updateProfile/${id}`, formData);
export const sendResetLink = (email) => API.post('/auth/send-reset-link', { email });
export const resetPassword = (token, newPassword) => API.post(`/auth/reset-password/${token}`, { newPassword });
export const deleteUser = (id) => API.delete(`/user/${id}`);
export const deleteMyAccount = (id) => API.delete(`/user/delete-self/${id}`);
export const fetchUsers = () => API.get('/user/users');
export const fetchUser = (id) => API.get(`/user/${id}`);
export const fetchLoginData = (by) => API.get(`/analytics/logins/${by}`);


/**
 * @returns {Promise<import('axios').AxiosResponse<Video[], any>>}
**/
export const fetchVideos = () => API.get('/video/videos');
/**
 * @typedef {{_id: string, title: string, url: string, category: string, subCategory: string, totLikes: number, totDislikes: number, views: number}} Video
 * @param {{title: string, url: string, category: string, subCategory: string}} videoData The video data.
 * @returns {Promise<import('axios').AxiosResponse<Video, any>>}
**/
export const createVideo = (videoData) => API.post('/video/upload', videoData);
export const updateVideo = (id, videoData) => API.patch(`/video/${id}`, videoData);
export const setVideoReaction = (videoId, reaction) => API.patch(`/video/react/${videoId}`, { reaction });
export const deleteVideo = (id) => API.delete(`/video/${id}`);
export const incrementViewCount = (id) => API.patch(`/video/view/${id}`);
export const getVideoViewsByUrl = (url) => API.get(`/video/views/${encodeURIComponent(url)}`);

/**
 * @typedef {{_id: string, bench_number: number, latitude: number, longitude: number, location: string, videos: {title: string, url: string}[]}} Bench
 * @returns {Promise<import('axios').AxiosResponse<Bench[], any>>}
 */
export const fetchBenches = () => API.get('/bench/benches');
export const fetchBenchVideos = (benchNumber) => API.get(`/bench/benches/${benchNumber}/videos`);
export const updateVideoBenches = (video, benches) => API.patch(`/bench/benches/update`, { video, benches });
export const updateBench = (id, benchData) => API.patch(`/bench/benches/${id}`, benchData);
export const createBench = (benchData) => API.post('/bench/benches', benchData);
export const deleteBench = (id) => API.delete(`/bench/benches/${id}`);
export const getAnalyticsData = () => API.get('/analytics-data');

export const fetchTrails = () => API.get('/trail/trails');
export const fetchTrail = (id) => API.get(`/trail/${id}`);
export const incrementTrailUsage = (id) => API.patch(`/trail/${id}/increment`);
export const createTrail = (trailData) => API.put('/trail/create', trailData);
export const updateTrail = (id, trailData) => API.patch(`/trail/${id}`, trailData);
export const deleteTrail = (id) => API.delete(`/trail/${id}`);

export const submitFeedback = (feedbackData) => API.post('/feedback/submit', feedbackData);
export const fetchFeedbacks = () => API.get('/feedback/feedbacks');
export const deleteFeedback = (id) => API.delete(`/feedback/${id}`);
